export default __webpack_public_path__ + "static/media/memoryItem.da8c6297.png";